import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssVarsProvider } from '@mui/joy/styles';
import './index.css';
import App from './App';
import { joyAppTheme } from './theme/joyAppTheme';
import { AuthProvider } from './auth/AuthContext';

function suppressResizeObserverLoopError(event: ErrorEvent): void {
  if (
    event.message ===
    'ResizeObserver loop completed with undelivered notifications.'
  ) {
    event.stopImmediatePropagation();
  }
}
window.addEventListener('error', suppressResizeObserverLoopError, true);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <CssVarsProvider theme={joyAppTheme} defaultMode="system">
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </CssVarsProvider>
  </React.StrictMode>
); 